module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Standard reference periods"},"de":{"label":"Standard-Referenzperioden"}}')
  delete Component.options._Ctor
}
